module.exports = __webpack_public_path__ + "static/img/345.45ff8733.png";